import { render } from "./index.vue?vue&type=template&id=2a030000&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2a030000&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Border-Card-UI/Border-Card-UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a030000"]])

export default __exports__